import { parse } from "date-fns";

import { IAgent } from "store/entities/agents";
import { ITeam, ITeamSettings } from "store/entities/teams/interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deserializeSettings(settings: { [key: string]: any }): ITeamSettings {
  const { notifyTeamAboutAssignedTicket, notifyTeamAboutRequestersActivity, tagReminder } = settings;

  return {
    notifyTeamAboutAssignedTicket,
    notifyTeamAboutRequestersActivity,
    tagReminder,
  };
}

export default abstract class TeamSerializer {
  static deserializeTeamAgentIds(teamId: string, agents: IAgent[]): string[] {
    return agents.filter(agent => agent.teamIds.includes(teamId)).map(agent => agent.id);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: { [key: string]: any }, agents: IAgent[], defaultTeamId: string): ITeam {
    const teamId = data.ID;
    return {
      id: teamId,
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
      name: data.name,
      agentIds: TeamSerializer.deserializeTeamAgentIds(teamId, agents),
      isDefault: teamId === defaultTeamId,
      settings: deserializeSettings(data.settings),
      replyAddressID: data.replyAddressID,
      replyName: data.replyName,
      templateId: data.templateID,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserializeList(list: any, agents: IAgent[], defaultTeamId: string): ITeam[] {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return list.map((item: { [key: string]: any }) => TeamSerializer.deserialize(item, agents, defaultTeamId));
  }
}
